export enum AccountType {
    COMPANY = 'company',
    USER = 'user',
    KIOSK = 'kiosk'
}
